export const saveData = ({ data: [key, value], store }) => {
  store[key] = value;

  if (value ?? false) {
    window.localStorage.setItem(key, value);
  } else {
    window.localStorage.removeItem(key);
  }
};
